import { Outlet } from 'react-router-dom';

const MainContent = () => {
  return (
    <div>
      <div className="bg-white rounded-lg shadow-md h-[calc(100vh-4rem)] overflow-auto">
        <Outlet />
      </div>
    </div>
  );
};

export default MainContent;